'use strict';

/*global echo */
/*global isEmpty */

function MapAbstract(settings) {
    this.map = null;
    this.mapBounds = null;

    this.settings = null;

    this.callBacksList = [];
    this.tmpMapItemList = [];

    this.elevatorService = null;
    this.placesService = null;
    this.addressLoaderService = null;
}

MapAbstract.prototype = $.extend({}, {
    construtor: 'MapAbstract',

    initSearch: function initSearch() {
        var _this = this;

        var timeoutToSend   = null;
        var lastValue       = '';

        $('body').on('keyup change', '#' + _this.settings.mapID + 'MapContainer .mapSearchBox', function (e) {
            var $searchBox = $(this);

            if(lastValue === $searchBox.val()) {
                return;
            }
            lastValue = $searchBox.val();

            if(timeoutToSend !== null) {
                clearTimeout(timeoutToSend);
            }

            timeoutToSend = setTimeout(function () {
                _this.findPlaceByQuery($searchBox.val());
            }, 500);

            if (e.keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });
        return _this;
    },

    getAddressByLatLng: function getAddressByLatLng(item, callBackFunction) {
        var _this = this;

        _this.addressLoaderService.addRequest('addressByLatLng', item, callBackFunction);
        return _this;
    },

    removeAllTmpItems: function removeAllTmpItems() {
        var _this = this;

        for(var i = 0; i < _this.tmpMapItemList.length; i++) {
            _this.tmpMapItemList[i].removeFromMap();
        }
        _this.tmpMapItemList = [];
        return _this;
    },

    callCallBack: function callCallBack(callBackName, param) {
        var _this = this;

        if(!isEmpty(_this.callBacksList[callBackName])) {
            _this.callBacksList[callBackName](param);
        }
        return _this;
    },

    getDefaultSettings: function getDefaultSettings() {
        var _this = this;

        var defaultSettings = {
            mapID: null,
            initZoom: 10,
            initLatitude: 0,
            initLongitude: 0,
            initMapType: null,

            mapEditable: false,
            mapCenterAfterInsertMarker: false,
            mapEnableClustering: false,
            mapHasSearchBox: false,

            changeMapBoundsZoom: 16,

            defaultMarkerIcon: null,
            searchMarkerIcon: '/images/icons/search_icon.png'
        };

        return _this.updateDefaultSettings(defaultSettings);
    },

    updateDefaultSettings: function updateDefaultSettings(settings) {
        return settings;
    },

    initMap: function initMap(settings) {
        var _this = this;

        var defaultSettings = _this.updateDefaultSettings(_this.getDefaultSettings());
        _this.settings = $.extend(defaultSettings, settings);

        if(_this.settings.mapHasSearchBox) {
            _this.initSearch();
        }
        return _this;
    }
});
